<template>
    <div class="sidebar-outline" :class="{closed: isClose, top: isTop}">
        <button type="button"
            id="btn-toggle"
            class="btn btn-outline-secondary btn-lg"
            :style="buttonStyle"
            :class="{closed: isClose, cloudy: isWriting}"
            @click="toggle()">
            <i class="far fa-sticky-note" v-if="isClose || (!isClose && !isTop)"></i>
            <i class="fas fa-times" v-else></i>
        </button>
        <div class="sidebar" :class="{closed: isClose}">
            <div class="sidebar-body">
                <div class="sidebar-wrapper">
                    <button type="button" class="btn btn-light btn-block btn-square" @click="toggle()">
                        閉じる
                        <i class="fas fa-chevron-right"></i>
                    </button>
                    <div class="py-3" v-if="section_id">
                        <div class="text-pane">
                            <textarea
                                ref="plot"
                                class="editor form-control rounded-0"
                                v-model="section.plot"
                                placeholder="プロットを入力..."
                                v-show="isEdit"
                                @blur="save()"
                                @keydown="input($event)"></textarea>
                            <div class="dummy" :class="{'text-muted': !section.plot}" @click="editPlot()">{{$filters.truncate(dummy, 140)}}</div>
                        </div>
                    </div>
                    <notes ref="notes" @searchNote="$emit('searchNote')" :fullpage="fullpage" :book_id="book_id"></notes>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="./sidebar.scss" scoped lang="scss"></style>
<style scoped lang="scss">
.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 0;
    border-radius: .7rem;
    .dummy {
        overflow: hidden;
        font-size: 0.75rem;
        line-height: 1.3rem;
        box-sizing: border-box;
        padding: 0.375rem 1rem;
        min-height: 80px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
    }
    .editor {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 0.75rem;
        line-height: 1.3rem;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0.375rem 1rem;
        width: 100%;
        height: 100%;
        border: 0;
        border-radius: .375rem;
        color: #123;
        resize: none;
        background-color: #fff;
        &:focus {
            outline: none;
        }
    }
}
@media screen and (max-width: 770px) {
    .text-pane {
        .editor {
            padding: 0.375rem 0rem;
        }
        .dummy {
            padding: 0.375rem 0rem;
        }
    }
}
</style>


<script>
import notes from "pages/mypage/books/notes/notes";
export default {
    components: {
        notes
    },
    props: {
        book_id: {
            required: true,
        },
        section_id: {
            default: null,
        },
        order: {
            default: 1
        },
        isWriting: {
            default: false,
        },
    },
    data() {
        return {
            isClose: true,
            isTop: false,
            section: {},
            org_plot: null,
            isEdit: false,
        }
    },
    methods: {
        load() {
            if (! this.section_id) {
                this.section = {};
                return;
            }
            axios.get("/mypage/book/plan/section", {params: {
                book_id: this.$route.params.book_id,
                id: this.section_id
            }}).then(res => {
                this.section = res.data;
                this.org_plot = res.data.plot;
            }).catch(err => { alert.err(err) });
        },
        save() {
            this.isEdit = false;
            if (this.org_plot == this.section.plot) return;
            axios.post("/mypage/book/plot/save", this.section).then(res => {
                alert.msg(res.data);
            }).catch(err => { alert.err(err) });
        },
        toggle(isClose = null) {
            if (isClose !== null) {
                this.isClose = isClose;
                this.isTop = false;
            } else {
                if (!this.isClose && !this.isTop) {
                    this.isTop = true;
                } else {
                    this.isClose = !this.isClose;
                    this.isTop = !this.isClose;
                }
                this.$emit("toggle", this.isClose);
            }
        },
        input(ev) {
            if (ev.code === "Enter") {
                ev.preventDefault();
            }
        },
        editPlot() {
            this.isEdit = true;
            setTimeout(() => {
                this.$refs.plot.focus();
            });
        }
    },
    watch: {
        section_id(n, o) {
            this.load();
        }
    },
    computed: {
        buttonStyle() { return { "top": (this.order * 46 + 50) + "px" }; },
        fullpage() {
            if (this.section_id) {
                return false;
            }
            return true;
        },
        dummy() {
            if (!this.section.plot) {
                return "プロットを入力...";
            }
            return this.section.plot + '\u200b'
        },
    },
    mounted() {
        this.load();
    }
}
</script>